import _taggedTemplateLiteral from "/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { createGlobalStyle } from 'styled-components';
import { TitilliumWebFontFace } from '@accesa/styleguide/styled/font-face';
export var PrimaryFont = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), TitilliumWebFontFace);